export const isWeather = process.env.VUE_APP_ENV === 'local' ||
    (process.env.VUE_APP_ENV === 'development' && process.env.VUE_APP_LOCALE === 'US') ||
    process.env.VUE_APP_ENV === 'production';
export const APPLIANCE_TYPE = {
    HEAT_PUMP: 'HeatPump',
    AIR_CONDITIONER: 'Air Conditioner',
    SMART_PLUG: 'Smart Plug',
    TV: 'TV',
};
export const isUS = process.env.VUE_APP_LOCALE === 'US';
